import gql from "graphql-tag";

//Get network cities for CYO and CYU
export const GET_NETWORK_CITIES = gql`
    query networkCities($networkID: String!) {
        networkCities(networkID: $networkID) {
          departures {
              year
              months
            }
            cities {
              name
            }
        }
    }
`;


//Get the next destination for CYO and CYU
export const GET_NEXT_CITIES = gql`
    query nextCities($networkID: String!, $fromCity:String!) {
        nextCities(networkID:$networkID, fromCity:$fromCity) {
            name
            from
            to
            segmentId
            stops {
              name
              stop_id
            }
        }
    }
`;

//Get the next destination and products for CYO and CYU
export const GET_NEXT_DESTINATION = gql`
    query next($bookingId: String!, $maxWait:Int) {
        next(bookingId: $bookingId, maxWait:$maxWait) {
            routes {
              name
              from
              to
              stops {
                type
                name
                stop_id
                nights_step
                cityInfo{
                    hero
                }
              }
              firstDeparture
            }
            products {
              name
              tourId
              groupId
              hero
              duration
              pricesFrom {
                iso_currency_code
                amount
              }
              startCity {
                name
              }
              endCity{
                name
              }
            }
        }
    }
`;


//Get the city departure dates
export const GET_CITY_DEPARTURE = gql`
  query getCityDepartures($cityName:String!, $date:String){
    getCityDepartures(cityName:$cityName, date:$date){
      departure_date
    }
  }
`;
